export default __webpack_public_path__ + "static/media/programmer.de7eee1c.svg";